import * as React from "react"
import H2 from "../../../atoms/typography/H2"
import { HorizontalSpacer } from "../../../atoms/spacers"
import H1 from "../../../atoms/typography/H1"
import H3 from "../../../atoms/typography/H3"
import styled from "styled-components"
import { Col, Row } from "react-grid-system"
import TextInput from "../../TextInput"
import SmallColorfulButton from "../../../atoms/buttons/SmallColorfulButton"
import Body from "../../../atoms/typography/Body"

const ColoredTitle = styled(H1)`
  background: ${(props) => props.theme.gradients.red};
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 700;
`

const MultilineTextField = styled.textarea`
  width: 100%;
  display: flex;
  height: 9.375rem;
  padding: 1rem;
  align-items: flex-start;
  justify-content: flex-start;
  border-radius: 0.75rem;
  background: ${(props) => props.theme.colors.greyLighter};
  box-shadow: 0px 0px 4px 0px rgba(119, 119, 119, 0.25);
  border: none;
  outline: none;
  font-family: "Karla", sans-serif;
  font-size: 20px;
  color: ${(props) => props.theme.colors.greyDark};
  vertical-align: top;

  ::placeholder {
    color: ${(props) => props.theme.colors.greyPlaceholder};
    font-style: italic;
  }

  :disabled {
    background: transparent;
    color: ${(props) => props.theme.colors.greyDisabled};
  }
`

interface Props {
  onClose: () => void
}

const PreOrderModalContent: React.FC<Props> = ({ onClose }) => {
  const [formSent, setFormSent] = React.useState(false)
  const [formValues, setFormValues] = React.useState()

  const handleChangeForm = (event: any) => {
    const name = event.target.name
    const value = event.target.value

    setFormValues((values: any) => ({ ...values, [name]: value }))
  }

  const onSubmitForm = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    console.log("submit", formValues)
    setFormSent(true)
  }

  return (
    <div>
      {formSent ? (
        <div>
          <H2 textAlign="center">Thank you for pre-ordering Satcube Motion!</H2>
          <HorizontalSpacer spacing={2} />
          <H3 textAlign="center">We will reach out to you when an update on your order is available.</H3>
          <HorizontalSpacer spacing={2} />
          <Row justify="center">
            <SmallColorfulButton title="Go back to Motion" onClick={onClose} variant="red" />
          </Row>
        </div>
      ) : (
        <div>
          <H2>Pre-order</H2>

          <HorizontalSpacer spacing={0.5} />
          <ColoredTitle>Satcube Motion</ColoredTitle>
          <HorizontalSpacer spacing={2} />
          <H3>Hetsig text!!!</H3>
          <HorizontalSpacer spacing={2} />
          <form onSubmit={onSubmitForm}>
            <Row>
              <Col lg={6}>
                <TextInput
                  textFieldTitle="First name"
                  tabIndex={0}
                  placeholder="First name"
                  name="firstName"
                  id="firstName"
                  onChange={handleChangeForm}
                  autofocus
                  required
                />
              </Col>
              <Col lg={6}>
                <TextInput
                  textFieldTitle="Last name"
                  tabIndex={1}
                  placeholder="Last name"
                  name="lastName"
                  id="lastName"
                  onChange={handleChangeForm}
                  required
                />
              </Col>
            </Row>
            <HorizontalSpacer spacing={1} />
            <Row>
              <Col lg={6}>
                <TextInput
                  textFieldTitle="Email"
                  tabIndex={2}
                  placeholder="example@example.com"
                  name="email"
                  id="email"
                  onChange={handleChangeForm}
                  required
                />
              </Col>
              <Col lg={6}>
                <TextInput
                  textFieldTitle="Phone"
                  tabIndex={3}
                  placeholder="+ 00 xxxxxxxxx"
                  name="phone"
                  id="phone"
                  onChange={handleChangeForm}
                  required
                />
              </Col>
            </Row>
            <HorizontalSpacer spacing={1} />
            <Row>
              <Col lg={12}>
                <TextInput
                  textFieldTitle="Company"
                  tabIndex={4}
                  placeholder="Company name"
                  name="company"
                  id="company"
                  onChange={handleChangeForm}
                  required
                />
              </Col>
            </Row>
            <HorizontalSpacer spacing={2} />
            <Body>Message (optional)</Body>
            <HorizontalSpacer spacing={1.5} />
            <MultilineTextField
              tabIndex={5}
              placeholder="Type your message here..."
              name="message"
              id="message"
              onChange={handleChangeForm}
            />
            <HorizontalSpacer spacing={2} />
            <SmallColorfulButton variant="red" title="Submit" type="submit" tabIndex={6} />
          </form>
          <HorizontalSpacer spacing={1} />
        </div>
      )}
    </div>
  )
}

export default PreOrderModalContent
